module.exports = __webpack_public_path__ + "img/followUpSettings.053690f3.svg";